export default __webpack_public_path__ + "static/media/InstantCash.a7d5280e.png";